export const isDisabled = (rules, value) => (
    Array.isArray(rules) && rules.indexOf(value) > -1
)

export const isChecked = (value) => {
    if (typeof value === 'string') {
        return value === 'true';
    }
    else if (typeof value === 'number') {
        return Boolean(value);
    }
    return value;
}
